module.exports = __webpack_public_path__ + "static/media/cadou-dar-icon.7721e36e.svg";